import React from "react";
import { ReadMoreHtml } from "./readMoreHtml";
import { dateFormat } from "../helper";

export const DisplayHtmlContent = function({
  content = {},
  classes = "",
  length,
  showCreatedInfo = true
}) {
  const { comment, createdBy, createdDate } = content;
  return (
    <div className={classes}>
      {showCreatedInfo ? (
        <p style={{ color: "black", marginBottom: "5px" }}>
          <span>{createdBy}</span> | <span>{dateFormat(createdDate)}</span>
        </p>
      ) : null}
      {/* <ReadMore indentation={"-"} length={length || 200} content={comment} /> */}
      <ReadMoreHtml clamp={2} content={comment} descriptionWeight={true} />
    </div>
  );
};
